export const data = [
  ["Amniotomy", "Water releasing on its own"],
  [
    "Experiencing early labor at place of birth",
    "Experiencing early labor at home"
  ],
  ["Freedom to eat and drink in labor", "IV fluids for hydration"],
  ["Episiotomy", "Allowing for natural tearing/stretching of the perineum"],
  ["Immediate Cord Clamping", "Delayed cord clamping"],
  [
    "Labor starting within 1 week of guess date",
    "Labor starting at 2 weeks before or after guess date"
  ],
  [
    "Epidural for pain management",
    "Using natural comfort measures (no epidural)"
  ],
  ["Forceps/Vacuum assisted birth", "No forceps/vacuum"],
  ["Wearing your own clothing in labor", "Wearing a hospital gown in labor"],
  ["Water birth", "Land birth (non-water birth)"],
  [
    "Having the labor support team I want with me at all times",
    "Having your labor support team removed from your room"
  ],
  ["Continuous fetal monitoring", "Intermittent fetal monitoring"],
  ["Access to tub/shower in labor", "No access to shower/tub in labor"],
  [
    "Allowing labor to start on its own",
    "Pitocin and cervical ripening induction"
  ],
  ["Midwife", "OB"],
  [
    "Freedom of movement during labor and pushing stages",
    "In bed for labor and pushing phase"
  ],
  [
    "Allowing your labor to progress on its own",
    "Having your labor augmented with Pitocin"
  ],
  ["Birth Center/Home Birth", "Hospital Birth"],
  [
    "Following your body's urges to push",
    "Being told when and how long to push (purple pushing)"
  ],
  ["Vaginal birth", "Cesarean"],
  [
    "Pain medications (narcotics) for comfort",
    "Only non-pharmalogical comfort measures"
  ],
  ["Pushing while lying on your back", "Upright pushing"],
  [
    "Immediate uninterrupted skin-to-skin for at least one hour after birth",
    "Separation of mom and baby in the first hour after birth"
  ],
  [
    "Having the care provider of your choice attend your birth",
    "Having a care provider whom you've never met or don't like at attend your birth"
  ]
];
